import PropTypes from "prop-types";

// Components
import QESProviderBanner from "../../shared/QESProviderBanner";
import SigningStartScreen from "./SigningStartScreen";

/**
 * StandardQESFlow Component
 *
 * Handles non-Verimi QES provider flows:
 * - YouTrust (standard and exceptional JP)
 * - Nect
 * - Other QES providers
 *
 * Routes between YouTrust exceptional person flow and standard SigningStartScreen flow.
 */
const StandardQESFlow = ({
  isDetailDialog,
  selectedQESVendor,
  isExceptionalJPYousignFlow,
  signingScreenProps,
  isVollmachtCompleted,
  onCancelRequest,
  halterFormValues,
  hasSigningError = false,
}) => {
  // Hide cancel button only when vollmacht is completed (not when error exists - user should be able to cancel)
  const isComplete = isVollmachtCompleted;

  const vendorBanner = selectedQESVendor?.vendor ? (
    <QESProviderBanner
      provider={selectedQESVendor.vendor}
      onCancel={onCancelRequest}
      isComplete={isComplete}
      disabled={isComplete || isDetailDialog}
      hideCancel={hasSigningError}
    />
  ) : null;

  return (
    <>
      {vendorBanner}
      <SigningStartScreen
        isDetailDialog={isDetailDialog}
        {...signingScreenProps}
        isExceptionalJP={isExceptionalJPYousignFlow}
        halterFormValues={halterFormValues}
      />
    </>
  );
};

StandardQESFlow.propTypes = {
  selectedQESVendor: PropTypes.object.isRequired,
  isExceptionalJPYousignFlow: PropTypes.bool,
  signingScreenProps: PropTypes.object.isRequired,
  isVollmachtCompleted: PropTypes.bool,
  onCancelRequest: PropTypes.func.isRequired,
  hasSigningError: PropTypes.bool,
};

StandardQESFlow.defaultProps = {
  isExceptionalJPYousignFlow: false,
  isVollmachtCompleted: false,
};

export default StandardQESFlow;
